<script lang="ts">
  interface Props {
    name: string
  }

  let { name }: Props = $props()

  const normalized = $derived(name.toUpperCase())
  const kind = $derived.by(() => {
    if (normalized.includes('КОРНЕПЛОД')) return 'root'
    if (normalized.includes('ПЕР')) return 'pepper'
    if (normalized.includes('САЛАТ') || normalized.includes('ЗЕЛЕН')) return 'leaf'
    if (normalized.includes('КАПУСТ')) return 'cabbage'
    return 'default'
  })
</script>

<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <circle cx="24" cy="24" r="18" fill="rgba(122,181,71,0.12)" />

  {#if kind === 'root'}
    <path d="M24 12v24M18 15c0 0 3 2 6 2s6-2 6-2" stroke="#7AB547" stroke-width="2.5" stroke-linecap="round" />
    <ellipse cx="24" cy="30" rx="7" ry="9" fill="#7AB547" opacity=".7" />
  {:else if kind === 'pepper'}
    <path d="M24 10c1-1 3-1 3 1v2c4 3 6 8 5 13-1 5-5 9-8 9s-7-4-8-9c-1-5 1-10 5-13V11c0-2 2-2 3-1z" fill="#7AB547" opacity=".8" />
  {:else if kind === 'leaf'}
    <path d="M24 34C20 30 13 27 14 21c1-5 6-7 10-5 4-2 9 0 10 5 1 6-6 9-10 13z" fill="#7AB547" opacity=".8" />
    <path d="M24 34V20" stroke="#5a3a1a" stroke-width="1.5" />
  {:else if kind === 'cabbage'}
    <path d="M24 10c-3 4-8 7-8 12a8 8 0 0016 0c0-5-5-8-8-12z" fill="#7AB547" opacity=".8" />
    <path d="M24 16c-2 3-5 5-5 9a5 5 0 0010 0c0-4-3-6-5-9z" fill="#7AB547" />
  {:else}
    <circle cx="18" cy="22" r="5" fill="#7AB547" opacity=".6" />
    <circle cx="30" cy="22" r="5" fill="#7AB547" opacity=".6" />
    <circle cx="24" cy="30" r="5" fill="#7AB547" opacity=".8" />
  {/if}
</svg>
